export const environment = {
  production: false,
  mockAuth: false,
  mockAPI: false,
  apiUrl: 'http://localhost:3000/local',
  cognito: {
    region: 'eu-west-1',
    userPoolId: 'eu-west-1_cdI0g0lpP',
    userPoolClientId: 'vrv4qj2ugg6mr93r1c2r4h4kn',
    userPoolDomain: 'dev-bo-sme-week',
    redirectSignOut: window.location.protocol + '//' + window.location.host,
  },
  cookieStorage: {
    secure: false,
  },
  frontofficeUrl: 'http://localhost:4201',
};
